import { ref } from 'vue';

//HELPERS
import { PinCreateStep } from '../../types/pin.type';

export const usePinCreate = () => {
  const step = ref(PinCreateStep.CREATE);

  return {
    step,
    PinCreateStep,
  };
};
